module.exports = __webpack_public_path__ + "static/media/sidebar-3.70689a62.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sidebar-3.jpg
// module id = 638
// module chunks = 0